import React from 'react';
import { useGroups } from '../../hooks/useGroups';
import BaseAssignmentModal from './BaseAssignmentModal';
import GroupIcon from '@mui/icons-material/Group';

const GroupAssignmentModal = ({ open, onClose, onAssign, loading, assignedGroups = [] }) => {
  const { fetchGroups } = useGroups();

  return (
    <BaseAssignmentModal
      open={open}
      onClose={onClose}
      onAssign={onAssign}
      loading={loading}
      assignedItems={assignedGroups}
      fetchItems={fetchGroups}
      title='Gruppen zuweisen'
      itemNameKey='name'
      icon={GroupIcon}
    />
  );
};

export default GroupAssignmentModal;
